class productSizeChart {
  constructor(parent) {
    if (parent.length == 0) {
      return;
    }
    this.parent = parent;
    this.clickEvent();
  }

  clickEvent = () => {
    // Global document click event
    document.addEventListener('click', (e) => {
      // Size guide open click event
      if (e.target.classList.contains('size-guide-js') || e.target.closest('.size-guide-js')) {
        let productWrapper = e.target.closest('.main-product');
        let sizeChartModal = productWrapper.querySelector(".product-sizeguide-modal");
        if (!sizeChartModal) {
          return;
        }
        sizeChartModal.classList.add('active');
        document.body.classList.add('overflow-hidden');
      } else if (e.target.classList.contains('product-sizeguide-modal__toggle') || e.target.closest('.product-sizeguide-modal__toggle')) {
        // Size guide close click event
        let sizeChart = e.target.closest('.product-sizeguide-modal');
        if(sizeChart){
          sizeChart.classList.remove('active');
        }
        document.body.classList.remove('overflow-hidden');
      } else if (e.target.classList.contains('toggle-metric__switch') || e.target.closest('.toggle-metric__switch')) {
        // Size guide cm/in switch click event
        let wrapper = e.target.closest('.size-chart-modal-wrapper');
        let tables = wrapper.querySelectorAll('.data-table-wrapper');    
        tables.forEach((table)=> table.style['display'] = "none" );
        let that = null;
        if (e.target.classList.contains('toggle-metric__switch')) {
          that = e.target;
        } else {
          that = e.target.closest('.toggle-metric__switch')
        }
        if(that.getAttribute('data-metric') == 'in'){
          that.setAttribute('data-metric',"cm");
          let table = wrapper.querySelectorAll('.data-table-wrapper[data-metric="cm"]');
          table.forEach(ele => {
            ele.style['display'] = "block";
          });
        }else{
          that.setAttribute('data-metric',"in");
          let table = wrapper.querySelectorAll('.data-table-wrapper[data-metric="in"]');
          table.forEach(ele => {
            ele.style['display'] = "block";
          });
        }
      }
    })
  }
}

new productSizeChart(document.querySelectorAll('.product'));